import type { QueryClient } from '@tanstack/react-query';
import { redirect, type RouteObject } from 'react-router-dom';

const routes = (queryClient: QueryClient): RouteObject => ({
  path: 'store',
  children: [
    {
      path: '',
      loader: () => redirect('snapshot/new'),
    },
    {
      path: 'snapshot',
      lazy: () => import('./snapshot'),
      children: [
        {
          path: 'new',
          lazy: async () => {
            const { loader, Component } = await import('./snapshot/form');
            return { loader: loader(queryClient), Component };
          },
        },
        {
          path: ':snapshotId',
          lazy: async () => {
            const { loader, Component } = await import('./snapshot/form');
            return { loader: loader(queryClient), Component };
          },
        },
      ],
    },
    {
      path: 'bundles',
      lazy: () => import('./bundles'),
    },
    {
      path: 'preview',
      lazy: () => import('./preview'),
    },
  ],
});

export const storeRoute = (queryClient: QueryClient): RouteObject =>
  import.meta.env.VITE_ADMIN_DISABLED_FEATURE.includes('store')
    ? {}
    : routes(queryClient);
